import * as actionTypes from './actionTypes';

export function entitiesFetchSuccess(entities) {
  return {
    type: actionTypes.FETCH_SUCCESS,
    entities,
  };
}

export function setEntities2(entities, keyWindow) {
  return {
    type: actionTypes.FETCH_SUCCESS,
    entities,
    keyWindow,
  };
}
